// The apply endpoint's complete outcome vocabulary, mirroring BE's own ApplyOutcome union. Four of
// these are additionally pinned by a DB CHECK constraint, so the set does not drift casually.
enum ChatProposalApplyOutcome {
  APPLIED = "applied",
  CANCELLED = "cancelled",
  CONFLICT = "conflict",
  EXPIRED = "expired",
  FAILED = "failed",
  INVALID = "invalid",
  NOT_FOUND = "not_found",
  STALE = "stale",
}

export default ChatProposalApplyOutcome;
